import React from "react";
import PropTypes from "prop-types";
import { Grid, Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function EntityReactions({ metrics }) {
    const actions = [
        { label: "Reactions", value: metrics["Reactions"] || metrics["Likes"], icon: "thumb_up" },
        { label: "Comments", value: metrics["Comments"], icon: "chat_bubble" },
        { label: "Shares", value: metrics["Shares"], icon: "share" }
    ];

    return (
        <Card sx={{ p: 2, mb: 3, backgroundColor: "#f8f9fa", boxShadow: 1 }}>
            <Grid container justifyContent="space-around" alignItems="center">
                {actions.map((action, idx) => (
                    <Grid item key={idx} display="flex" flexDirection="column" alignItems="center">
                        <MDBox display="flex" alignItems="center" gap={0.5}>
                            <Icon color="text" fontSize="small">{action.icon}</Icon>
                            <MDTypography variant="h6" fontWeight="regular">
                                {typeof action.value === 'number' ? action.value.toLocaleString() : (action.value || 0)}
                            </MDTypography>
                        </MDBox>
                        <MDTypography variant="caption" color="text">
                            {action.label}
                        </MDTypography>
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
}

EntityReactions.propTypes = {
    metrics: PropTypes.object.isRequired,
};

export default EntityReactions;
